module.exports = __webpack_public_path__ + "img/icon-err.b5436217.png";